import Axios from "axios";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
    productRegistrationSubmit: (context, data) => {
        return Axios.post((<any>window).App.routes.YES_ProductRegistrationSubmit, data);
    },
    getTaxCountries: (context, data) => {
        return Axios.post((<any>window).App.routes.YES_GetTaxCountries, data);
    },
    getTaxCode: (context, data) => {
        return Axios.post((<any>window).App.routes.YES_GetTaxCode, data);
    },
    getAddressTypes: (context, data) => {
        return Axios.post((<any>window).App.routes.YES_GetAddressTypes, data);
    },
    getPrivacyPolicy: (context, data) => {
        return Axios.post((<any>window).App.routes.YES_GetPrivacyPolicy, data);
    },
    profileRegistrationSubmit: (context, data) => {
        return Axios.post((<any>window).App.routes.YES_ProfileRegistrationSubmit, data);
    },
    skipSurvey: (context, data) => {
        return Axios.post((<any>window).App.routes.YES_SkipSurvey, data);
    },
    surveyEuropeSubmit: (context, data) => {
        return Axios.post((<any>window).App.routes.YES_SurveyEuropeSubmit, data);
    },
    getDealers: (context, data) => {
        return Axios.post((<any>window).App.routes.YES_GetDealers, data);
    },
    dealerSurveySubmit: (context, data) => {
        return Axios.post((<any>window).App.routes.YES_DealerSurveySubmit, data);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};